(function () {
  angular.module("pcmCommon", [

  ]);

  angular.module("pcmCommon")
    .constant("_", window._);
  angular.module("pcmCommon")
    .constant("moment", window.moment);
})();



// WEBPACK FOOTER //
// ./app/pcm-common/pcmCommon.js